import { render, staticRenderFns } from "./ClaimCard.vue?vue&type=template&id=38d42dd5"
import script from "./ClaimCard.vue?vue&type=script&lang=js"
export * from "./ClaimCard.vue?vue&type=script&lang=js"
import style0 from "./ClaimCard.vue?vue&type=style&index=0&id=38d42dd5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports